export const BOOKING = {
  STATUS: {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    CANCELED: 'canceled'
  },
  LIMIT_MONTHS: 6
}

export const PageSection = { Hotel: 'hotel', Mobility: 'mobility', Experience: 'experience' }

export const TABS = [PageSection.Hotel, PageSection.Mobility, PageSection.Experience]

export const tiers = {
  'Tiering.upgrade.to.silver.rule': 'silver',
  'Tiering.upgrade.to.gold.rule': 'gold',
  'Tiering.upgrade.to.platinum.rule': 'platinum',
  'Tiering.upgrade.to.diamond.rule': 'diamond'
}

export type TierUpgrade = keyof typeof tiers

export enum GIFT_NAME_ENUM {
  DRINK = 'DRINK',
  COMPLIMENTARY_BREAKFAST = 'COMPLIMENTARY_BREAKFAST'
}

export enum GIFT_GENERATION_STATUS_ENUM {
  SUCCESS = 'SUCCESS'
}

export const CB_PROFIT_TYPE_APPLICABLE_DAYS = 'TITLE_APPLICABLE_DAYS'

export enum CB_PROFIT_CODE {
  TITLE_WEEK_END = 'TITLE_WEEK_END',
  TITLE_ALL_DAYS = 'TITLE_ALL-DAYS'
}

export enum CB_OFFER_TYPE {
  WEEKLY = 'weekly',
  WEEKEND = 'weekend'
}

export const CB_OFFER_TYPE_BY_PROFIT_CODE: Record<CB_PROFIT_CODE, CB_OFFER_TYPE> = {
  [CB_PROFIT_CODE.TITLE_WEEK_END]: CB_OFFER_TYPE.WEEKEND,
  [CB_PROFIT_CODE.TITLE_ALL_DAYS]: CB_OFFER_TYPE.WEEKLY
}

export enum BOOKING_STATUS_ENUM {
  CANCELLED = 'CANCELLED',
  UPCOMING = 'UPCOMING',
  ONGOING = 'ONGOING',
  PASSED = 'PASSED'
}

export enum HotelBookingOriginType {
  TARS = 'TARS',
  ACRS = 'ACRS'
}
